import config from 'config';

/**
 * Build the absolute download URL for a CSV export. Single source of truth so
 * the API path lives in one place across the table row's Download button and
 * the export-ready toast.
 *
 * The endpoint pair (`/download-study-export`, `/download-panel-export`) is
 * mirrored from the API; keep it in sync with `panelfox-api` routes when
 * either route changes.
 *
 * @param {'study'|'panel'} kind Selects which download endpoint to hit.
 * @param {number|string} id Export ID for the resource being downloaded
 *     (study export ID for `'study'`, panel export ID for `'panel'`).
 * @param {number|string} accountId Caller's account ID — required by the API
 *     for authorization.
 * @returns {string} Absolute URL suitable for an `<a href>` opening in a new tab.
 */
export function buildExportDownloadUrl(kind, id, accountId) {
    const path = kind === 'study' ? '/download-study-export' : '/download-panel-export';
    return `${config.API_URL}${path}?id=${id}&account_id=${accountId}`;
}
